type GtmEventPayload = Record<string, unknown> & { event: string }

// Los eventos de GTM solo deben viajar al contenedor real en producción.
// dev/beta corren el mismo contenedor (GTM-PH3B94G5, ver public/index.html)
// y sin este guard el tráfico de pruebas se mezcla con el de usuarios reales.
export const pushGtmEvent = (payload: GtmEventPayload): void => {
  if (process.env.REACT_APP_ENVIRONMENT !== 'production') return
  if (typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []
  window.dataLayer.push(payload)
}
